export default __webpack_public_path__ + "static/media/360.c78831cc.jpg";